import React, { FunctionComponent } from 'react';
import { NavLink as ReactRouterNavLink } from "react-router-dom";

interface Props {
    to: string;
    children: any;

    exact?: boolean;
}

const NavLink: FunctionComponent<Props> = ({ to, children, exact }) => {

    return (
        <ReactRouterNavLink to={to} className={({ isActive }) => `navbar__link ${isActive ? 'navbar__link--active' : ''}`}  end>
            { children }
        </ReactRouterNavLink>
    );
};

export default NavLink;
